import React, { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowUp,
  faArrowDown,
  faCog,
  faTag,
  faCutlery,
  faRotateExclamation,
  faHouse,
  faQuestion,
  faHourglass
} from "@fortawesome/pro-solid-svg-icons";
import CurrentTime from "./CurrentTime";
import {
  availRed,
  availAmber,
  freshRed,
  freshAmber,
  wasteRed,
  wasteAmber
} from "./variable-vault";
import { getArea, getTimeStamp } from "./functions";

interface NavBarProps {
  handleShowSettings: () => void;
  handleShowHome: () => void;
  handleShowWaves: () => void;
  handleShowHighRiskRotation: () => void;
  storeName: string;
  isFOH: boolean;
  setJoyrideRun: (run: boolean) => void;
  tempCheckTrial: boolean;
  rotationAlert: boolean;
  disableHelp: boolean;
}

const NavBar: FunctionComponent<NavBarProps> = ({
  storeName,
  handleShowSettings,
  handleShowHome,
  handleShowWaves,
  handleShowHighRiskRotation,
  isFOH,
  setJoyrideRun,
  tempCheckTrial,
  rotationAlert,
  disableHelp
}) => {
  const handleSwitch = () => {
    window.dataLayer.push({
      event: "Navigation",
      value: "Switch foh/boh",
      bakery: storeName,
      bakery_area: getArea(isFOH),
      time: getTimeStamp()
    });

    let url = new URL(window.location.href);

    if (isFOH) {
      url.searchParams.delete("foh");
    } else {
      url.searchParams.set("foh", "1");
    }

    window.location.href = url.toString();
  };

  const handleHelp = () => {
    // Scroll to top
    document
      .querySelector(".scroll-table")
      ?.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setJoyrideRun(true);
  };

  return (
    <nav className="App-navbar">
      <div className="nav-title-container">
        <div
          className="store-name left-aligned-button h4"
          onClick={handleShowSettings}
        >
          {storeName}
        </div>
      </div>
      <div className="settings-actions">
        <div className="settings-actions__icons">
          <CurrentTime />
          <div
            onClick={handleShowHome}
            className="settings-actions__icon cog-icon-container jr-home"
          >
            <FontAwesomeIcon icon={faHouse as IconProp} />
          </div>
          {tempCheckTrial && (
            <div
              onClick={handleShowHighRiskRotation}
              className={`nav-icon settings-actions__icon cog-icon-container jr-high-risk${
                rotationAlert ? " nav-icon--alert" : ""
              }`}
            >
              <FontAwesomeIcon icon={faRotateExclamation as IconProp} />
            </div>
          )}
          {/* <div
            onClick={handleShowWaves}
            className="settings-actions__icon cog-icon-container jr-wave-planner"
          >
            <FontAwesomeIcon icon={faHourglass as IconProp} />
          </div> */}
          <div
            onClick={handleShowSettings}
            className="settings-actions__icon cog-icon-container jr-settings"
          >
            <FontAwesomeIcon icon={faCog as IconProp} />
          </div>
          <div
            onClick={handleSwitch}
            className="settings-actions__icon cog-icon-container jr-foh-boh-toggle"
          >
            <FontAwesomeIcon
              icon={isFOH ? (faTag as IconProp) : (faCutlery as IconProp)}
            />
          </div>
          <button
            onClick={handleHelp}
            disabled={disableHelp}
            className="settings-actions__icon cog-icon-container jr-bird-icon"
          >
            <FontAwesomeIcon icon={faQuestion as IconProp} />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
